import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../common/constants';
import ContactInquiry from './ContactInquiry';

const ContactInquiryWrapper = () => {
  return (
    <Switch>
      <Route exact path={ROUTES?.CONTACT_INQUIRY} component={ContactInquiry} />
    </Switch>
  );
};

export default ContactInquiryWrapper;
